import ShortableText from 'components/common/ShortableText';
import { HubertBadge } from 'components/HubertUI/HubertBadge';
import type { ComponentProps } from 'react';

interface Props extends ComponentProps<typeof HubertBadge> {
  shortDescription: string;
  fallbackText?: string;
}

const QuestionShortDescription = ({ shortDescription, fallbackText = '', ...props }: Props) => {
  if (!shortDescription || !shortDescription.length) {
    return (
      <HubertBadge {...props} variant={'warning'}>
        <ShortableText text={fallbackText} textLength={20} />
      </HubertBadge>
    );
  }

  return (
    <HubertBadge {...props} variant={'secondary'}>
      {shortDescription}
    </HubertBadge>
  );
};

export default QuestionShortDescription;
